import { Box } from '@material-ui/core';

import { LibraryPanelProps } from './LibraryPanel.props';
import { useStyles } from './LibraryPanel.styles';
// import { LIBRARIES } from './LibraryPanel.const';
import { ChangeEvent, useCallback, useContext, useEffect, useState } from 'react';
import { Libraries } from '@routes/TemplateView/TemplateView.const';

import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { content } from '@content';

import { TreatmentBuilderContext } from '@routes/TemplateView/TemplateView.const';

/**
 LibraryPanel component
 @returns {JSX.Element}
 */

export const LibraryPanel = ({ onChooseLibrary }: LibraryPanelProps): JSX.Element => {
  const styles = useStyles();
  const [tab, setTab] = useState(Libraries.IMAGES as string);

  const { leftPanelType } = useContext(TreatmentBuilderContext);

  const switchLibraryPanel = useCallback(
    (value) => {
      switch (value) {
        case Libraries.IMAGES:
          onChooseLibrary(Libraries.IMAGES);
          break;
        case Libraries.DATA_VISUALIZATIONS:
          onChooseLibrary(Libraries.DATA_VISUALIZATIONS);
          break;
        default:
          onChooseLibrary(Libraries.IMAGES);
          break;
      }
    },
    [onChooseLibrary],
  );

  const handleChangeTab = useCallback(
    (event: ChangeEvent<unknown>, value: string) => {
      if (value !== null) {
        setTab(value);
        switchLibraryPanel(value);
      }
    },
    [switchLibraryPanel],
  );

  useEffect(() => {
    setTab(leftPanelType);
    switchLibraryPanel(leftPanelType);
  }, [leftPanelType, switchLibraryPanel]);

  return (
    <Box className={styles.libraryPanel}>
      <ToggleButtonGroup value={tab} exclusive onChange={handleChangeTab} aria-label="Library Type">
        <ToggleButton className={styles.tab} data-left-tab value={Libraries.IMAGES} aria-label="Images">
          {content.graphics}
        </ToggleButton>
        <ToggleButton
          className={styles.tab}
          data-right-tab
          value={Libraries.DATA_VISUALIZATIONS}
          aria-label="Data Visualizations"
        >
          {content.dataVisualizations}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
